import { Icon } from 'gu-ui-kit'
import React from 'react'

export default () => {
  return {
    initial: {
      search: '',
      statuses: [],
    },
    configuration: {
      search: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'payment_profiles::payments.filters.dropdown.items.search.label',
        placeholder: 'payment_profiles::payments.filters.dropdown.items.search.label',
        order: 1,
        type: 'input',
      },
      statuses: {
        subbutton: {
          isVisible: (value = [], breakpoints) => value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'avatar1'}
            size={'s'}
            bgColor={'Accent-Confirm-Secondary'}
            color={'Label-Onsurface'}
          />
        ),
        label: 'payment_profiles::payments.filters.dropdown.items.statuses.label',
        position: 'dropdown',
        type: 'checkbox group',
        optionLabelPrefix: 'payment_profiles::payments.statuses.',
        options: ['new', 'pending', 'waiting', 'paid', 'canceled'],
      },
    },
  }
}
